/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDown } from '@fortawesome/free-solid-svg-icons';
import { HBox, VBox } from '../../../../../components/Box';
import { Button } from '../../../../../components/Buttons';
import { Checkbox } from '../../../../../components/Checkbox';
import { ArrowDown, ArrowUp, Car, ChevronRight, Home } from '../../../../../components/Icon';
import { Loader } from '../../../../../components/Loader';
import { PageHeader } from '../../../../../components/PageHeader';
import { Sort } from '../../../../../components/Sort';
import { formatCurrency, formatLicensePlate } from '../../../../../utils/string';
import { COLOR_TABLE_HEADER, COLOR_HEADER } from '../../../../../vars';
import { selectWorks } from '../../../../Api/selectors';
import { KanbanProgressBar } from '../../../../KanbanBoards/components/ProgressBar';
import {
  changeVehicleFilter,
  addVehicleToBulkActionsList,
  removeVehicleFromBulkActionsList,
  setVehiclesSort,
  applyVehicleFilters,
  removeAllVehicleFromBulkActionsList,
} from '../../../actions';
import { VehicleSearch } from '../../../components/Search';
import { REQUEST_VEHICLES, REQUEST_VEHICLE_FROM_AUTOTELEX, SET_VEHICLES_SORT } from '../../../constants';
import {
  selectVehicleCount,
  selectVehiclePaginator,
  selectVehicles,
  selectVehicleBulkActionsList,
  selectVehicleFilter,
} from '../../../selectors';
import { VehicleStatusLabel } from '../../../components/VehicleStatusLabel';
import { getPropByName } from '../../../../../utils/props';
import { Pagination } from '../../../../../components/Pagination';
import { BulkActionsCard } from '../../BulkActions/BulkActionsCard';
import { setScrollPosition } from '../../../../Actions/actions';
import { toggleNotification } from '../../../../Companies/actions';
import { Notification } from '../../../../../components/Notification';
import { selectNotification } from '../../../../Companies/selectors';
import { VehicleAvatarSlider } from '../../../../../components/VehicleAvatarSlider';
import { getDate, getDaysInStock, getVehicleStatusLabel } from '../../../helpers';

import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import CardComponent from '../../../../../containers/App/Components/Card/Card';
import CheckboxComponent from '../../../../../containers/App/Components/Checkbox/Checkbox';
import LoadingCard from '../../../../../containers/App/Components/LoadingCard/LoadingCard';
import LoadingFilters from '../../../../../containers/App/Components/LoadingFilters/LoadingFilters';
import PaginationComponent from '../../../../../containers/App/Components/Pagination/Pagination';
import s from './overview.module.css';
import cn from 'classnames';
import { getSirvImgUrlExterior } from '../../../helpers';
import ImageCarousel from '../../../../../containers/App/Components/Carousel/Carousel';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import env from '../../../../../env';
import { AppClientId } from '../../../../Shared/constants';

import { RegplateLabel } from '../../../components/RegplateLabel';
import { VehicleAvatar } from '../../../../../components/VehicleAvatar/installations/3';
import { WithWorkflow } from '../../../../Workflows/components/WithWorkflow';
dayjs.extend(customParseFormat);

const Container = styled.div`
  .filters {
    // padding: 24px;
    margin-top: 56px;
    // position: relative;
    margin-bottom: 22px;
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 15px;
    }

    .button-add {
      margin-left: auto;
    }
  }

  .rows {
    .check-col {
      min-width: 40px;
      text-align: center;
    }
    background-color: white;
    .header {
      background-color: ${COLOR_TABLE_HEADER};
      color: #313a46;

      .box {
        height: 52px;
        white-space: nowrap;
        flex-shrink: 0;
        > div {
          font-weight: 600;
        }
      }
      @media (max-width: 768px) {
        display: none;
      }
    }

    .header-col {
      overflow: hidden;
      width: auto;
      width: 87px;
      font-size: 12px;

      text-transform: capitalize;
      justify-content: flex-start;

      &.col-regplate {
        width: 70px;
      }

      &.col-info {
        margin-left: 165px;
        justify-content: flex-start;
        width: 335px;
      }

      &.col-vin {
        width: 170px;
      }

      &.col-year {
        width: 150px;
        justify-content: flex-start;
      }

      &.col-b2bPrice {
        width: 80px;
      }

      &.col-b2cPrice {
        width: 80px;
      }
      &.col-buying_contact {
        width: 120px;
      }
      &.col-date_expected {
        width: 130px;
        margin-left: 0;
      }
      &.col-transmission_type {
        width: 54px;
      }

      &.col-body_type {
        width: 140px;
      }

      &.col-status {
        width: 110px;
      }
      &.col-isHome {
        width: 30px;
      }
    }

    .item-cell {
      text-align: right;
      font-size: 12px;
      padding: 4px;
      width: 87px;

      &:last-child {
        justify-content: flex-end;
      }
    }

    .col-transmission_type {
      width: 54px;
    }
    .col-check {
      text-align: center;
      width: 40px;
    }
    .col-regplate {
      width: 70px;
    }
    .col-info {
      width: 500px;
      overflow: hidden;
      .brand-model {
      }
      .model-info {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 330px;
      }
    }

    .col-mileage {
    }

    .col-vin {
      width: 170px;
      white-space: nowrap;
    }

    .col-year {
      width: 150px;
    }
    .col-buying_contact {
      width: 120px;
    }
    .col-status {
      width: 110px;
    }

    .col-date_expected {
      width: 130px;
      text-align: left;
    }

    .col-body_type {
      width: 120px;
    }

    .col-isHome {
      width: 30px;
    }

    .col-b2cPrice {
      width: 80px;
      text-align: left;
    }
    .item-row {
      border-bottom: 1px solid ${COLOR_HEADER};
    }
  }

  .icon-up,
  .icon-down {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const StatsGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 10px;
  padding: 12px;
  font-size: 12px;
`;

const RemarkDataIconWrapper = styled.div`
  a {
    position: relative;
  }

  .alt-block {
    position: absolute;
    left: 0;
    margin-left: -100px;
    top: ${props => (props.innerWidth < 768 ? '110%' : '100%')};
    z-index: 2;
    min-width: ${props => (props.innerWidth < 768 ? '150px' : '250px')};
    max-width: ${props => (props.innerWidth < 768 ? '150px' : '300px')};
    padding: 4px 8px;
    background-color: #cccccc;
    color: #6d727b;
    white-space: normal;
    text-align: left;
    border-radius: 5px;
  }
`;

const STATE = {
  sort: null,
  sort_direction: 'down',
  isShowAddModal: false,
  isShowMore: true,
  currentPage: 0,
  localPaginator: {
    limit: 50,
    offset: 0,
    itemsCount: 0,
  },
  filteredVehicles: [],
};

/* eslint-disable react/prefer-stateless-function */
class VehiclesOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {
    if (this.props.vehicles?.length === this.props.bulkActionsList?.[this.bulkActionItemsPage]?.length) {
      this.setState({ allSelected: true });
    }
    if (this.locationState?.fromVehicleDetails) {
      this.props.fetch();
    }
    if (this.props.weblogin) {
      this.setState({
        localPaginator: {
          ...this.state.localPaginator,
          itemsCount: this.props.webloginVehicles.length,
        },
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.vehicles?.length !== this.props.bulkActionsList?.[this.bulkActionItemsPage]?.length) {
      this.setState({ allSelected: false });
    }

    if (this.props.vehicles?.length === this.props.bulkActionsList?.[this.bulkActionItemsPage]?.length) {
      this.setState({ allSelected: true });
    }

    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
    if (this.props.weblogin && prevProps.webloginVehicles !== this.props.webloginVehicles) {
      this.setState({
        localPaginator: {
          ...this.state.localPaginator,
          itemsCount: this.props.webloginVehicles.length,
        },
      });
    }
  }

  get vehicles() {
    if (this.props.weblogin && Array.isArray(this.state.filteredVehicles)) {
      return this.state.filteredVehicles;
    }
    return this.props.weblogin ? this.props.webloginVehicles : this.props.vehicles;
  }

  get vehiclesCount() {
    if (this.props.weblogin && Array.isArray(this.state.filteredVehicles)) {
      return this.state.filteredVehicles?.length;
    }
    return this.props.weblogin ? this.props.webloginVehicles?.length : this.props.count;
  }

  get locationState() {
    return this.props.location?.state?.state;
  }

  get noSortingTypes() {
    return ['isHome', 'regplate', 'info'];
  }

  getTypesTosort(type) {
    let types = {
      brand_name: 'info',
      date_first_allowance: 'year',
      financial_price_b2b_incl_vat_btpm: 'b2bPrice',
      financial_price_b2c: 'b2cPrice',
    };

    return types[type] || type;
  }

  sortOn(field) {
    let direction = 'none';
    let sortType;

    switch (field) {
      case 'year': {
        sortType = 'date_first_allowance';
        break;
      }
      case 'b2bPrice': {
        sortType = 'financial_price_b2b_incl_vat_btpm';
        break;
      }
      case 'b2cPrice': {
        sortType = 'financial_price_b2c';
        break;
      }

      default:
        sortType = field;
    }

    let order;
    if (this.props.filter?.sortType == sortType) {
      if (!this.props.filter?.order) order = 'asc';
      if (this.props.filter?.order == 'asc') order = 'desc';
    } else {
      order = 'asc';
    }
    this.setState({ direction: !order ? 'none' : order == 'asc' ? 'up' : 'down' });

    order ? this.props.setSort(sortType, order) : this.props.setSort('', '');
  }

  selectPage = newPage => {
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);

    this.setState(
      prev => ({
        currentPage: newPage,
      }),
      this.props.changeFilter('offset', newOffset),
    );
  };

  cols() {
    return [
      'regplate',
      'info',
      // 'transmission_type',
      //'vin',
      'year',
      // /  'mileage',
      //'b2bPrice',
      //'b2cPrice',

      //only for hooikammer installation
      //'creditor_company',
      'in_uitslag',
      // 'restBpm',
      //'priceType',
      //'buying_contact',
      // 'show_on_sales_website',
      //'date_expected',
      'workflow_id',
      'stadagen',
      'status',
      'isHome',
    ];
  }

  isSelectedVehicle(vehicleId) {
    const vehicles = this.bulkActionList;

    return vehicles?.filter(item => item?.id == vehicleId)?.length == 1;
  }

  onSelectVehicle(e, vehicle) {
    e.stopPropagation();

    if (this.isSelectedVehicle(vehicle?.id)) {
      return this.props.removeVehicleFromBulkActionsList(vehicle?.id, this.bulkActionItemsPage);
    }

    return this.props.addVehicleToBulkActionsList(vehicle, [], this.bulkActionItemsPage);
  }

  get bulkActionItemsPage() {
    return this.state.currentPage ? this.state.currentPage + 1 : 1;
  }

  onSelectAll(e, vehicles) {
    e.stopPropagation();

    return this.props.addVehicleToBulkActionsList(null, vehicles, this.bulkActionItemsPage);
  }

  get bulkActionList() {
    const values = Object.values(this.props.bulkActionsList);
    const allItems = values?.reduce((prev, currentValue) => {
      const prevArray = prev?.length ? prev : [];
      const currArray = currentValue?.length ? currentValue : [];
      return [...prevArray, ...currArray];
    }, []);
    return allItems;
  }

  onRemoveAll(e, vehicles) {
    e.stopPropagation();
    const currentPage = this.bulkActionItemsPage;
    return this.props.removeAllVehicleFromBulkActionList(currentPage);
  }

  toggleDiv = () => {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  };

  determineWeblogin = vehicle => {
    if (vehicle?.HOOI_inslag_done_date && !vehicle?.HOOI_uitslag_done_date) {
      return '3';
    } else if (vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized === '1') {
      return '4';
    } else if (!vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized === '1') {
      return '5';
    } else if (vehicle?.HOOI_inslag_done_date) {
      return '1';
    } else if (!vehicle?.HOOI_inslag_done_date) {
      return '2';
    }
    return '0';
  };

  filterVehicles = filterParams => {
    if (!filterParams) {
      this.setState({ filteredVehicles: this.props.webloginVehicles || [] });
      return;
    }

    if ((!filterParams.properties || filterParams.properties.length === 0) && !filterParams.searchString) {
      this.setState({ filteredVehicles: this.props.webloginVehicles || [] });
      return;
    }

    const filters = filterParams.properties.reduce((acc, cur) => {
      acc[cur.key] = cur.value.map(v => v.toLowerCase());
      return acc;
    }, {});

    const searchString = filterParams.searchString ? filterParams.searchString.toLowerCase() : '';
    const searchWords = searchString?.toLowerCase().split(/\s+/) || [];

    if (!this.props.webloginVehicles) {
      this.setState({ filteredVehicles: [] });
      return;
    }

    const filteredVehicles = this.props.webloginVehicles.filter(vehicle => {
      const vehicleWeblogin = this.determineWeblogin(vehicle);

      const matchesFilters = Object.keys(filters).every(key => {
        const vehicleProperty = vehicle[key] ? vehicle[key].toLowerCase() : '';
        const filterValues = filters[key];

        if (key === 'status') {
          return (
            filterValues.length === 0 ||
            filterValues.some(filterStatus => {
              if (filterStatus >= '1' && filterStatus <= '5') {
                return vehicleWeblogin === filterStatus;
              } else if (filterStatus === '0') {
                return vehicle.status === '5';
              } else if (filterStatus === '6') {
                return vehicle.status === '6';
              }
              return false;
            })
          );
        }

        return filterValues.length === 0 || filterValues.some(filterValue => vehicleProperty.includes(filterValue));
      });

      const matchesSearchString = searchString
        ? searchWords.length === 0 ||
          searchWords.every(word =>
            ['brand_name', 'model_name', 'id', 'regplate'].some(prop =>
              vehicle[prop]
                ?.toString()
                .toLowerCase()
                .includes(word),
            ),
          )
        : true;

      return matchesFilters && matchesSearchString;
    });

    this.setState({ filteredVehicles });
  };

  render() {
    const count = this.vehiclesCount;
    const vehicles = this.vehicles;
    const { localPaginator } = this.state;

    const {
      currentPage,
      localPaginator: { limit },
    } = this.state;
    const startIndex = currentPage * limit;
    const endIndex = startIndex + limit;

    const vehiclesToShow = this.props.weblogin ? this.state.filteredVehicles.slice(startIndex, endIndex) : vehicles;
    const totalCount = this.props.weblogin ? this.state.filteredVehicles.length : this.props.count;
    if (window.innerWidth >= 1024 && this.props.work) {
      return (
        <>
          <div className="container-fluid p-0">
            <PageHeader
              title={
                <>
                  <Home />
                  {this.lbl('vehicle.overview.title')}
                </>
              }
            ></PageHeader>
            <LoadingFilters />
          </div>
        </>
      );
    }
    return (
      <div className="container-fluid p-0">
        {!!this.bulkActionList?.length && (
          <BulkActionsCard bulkActionsList={this.bulkActionList} currentPage={this.bulkActionItemsPage} />
        )}
        {this.props.notification?.isShow == '1' && (
          <Notification>{this.lbl(`vehicle.details.bulk_action.${this.props.notification?.message}`)}</Notification>
        )}
        <PageHeader
          title={
            <>
              <Home />
              {this.lbl('vehicle.overview.title')}
              {count !== null ? <span className="label number">{count}</span> : null}
            </>
          }
          // breadCrumbs={
          //   <>
          //     <a href="/">Vindat</a>
          //     <ChevronRight />
          //     {this.lbl('vehicle.overview.title')}
          //   </>
          // }
        >
          {/* {window.innerWidth <= 768 &&
            <Permission permission={VEHICLE_CREATE}>
              <VehicleCreateModals />
            </Permission>
          } */}
          {/* {window.innerWidth <= 768 && (
            <Button inline small>
              <strong>{this.lbl('vehicle.overview.filter')}</strong>
              <FontAwesomeIcon icon={faSortAmountDown} style={{ marginLeft: 10 }} />
            </Button>
          )} */}
        </PageHeader>
        <div className="container-fluid p-0">
          <VehicleSearch
            weblogin={this.props.weblogin}
            webloginVehicles={this.props.webloginVehicles}
            filterVehicles={this.filterVehicles}
            // statuses={statusTranslations}
          />
        </div>

        {/* <div className="filters">
          <VBox left vCenter> */}
        {/* {window.innerWidth > 768 && (
              <Permission permission={VEHICLE_CREATE}>
                <VehicleCreateModals />
              </Permission>
            )} */}
        {/* <VehicleSearch />
          </VBox>
        </div> */}

        {window.innerWidth >= 1024 && count !== (null || 0) ? (
          <table className={cn('table', 'table-hover', 'mb-0', s.wrapper)}>
            <thead className="align-middle">
              <tr className={cn('align-middle', s.thead)}>
                <th className={s.headTh}>
                  <CheckboxComponent
                    disabled={this.props.weblogin}
                    checked={this.state.allSelected == '1'}
                    onChange={e => {
                      if (this.state.allSelected == '1') {
                        this.setState({ allSelected: '0' });
                        return this.onRemoveAll(e, this.vehicles);
                      }
                      this.setState({ allSelected: '1' });
                      return this.onSelectAll(e, this.vehicles);
                    }}
                  />
                </th>
                {this.cols().map((col, index) => (
                  <th className={s.headTh} key={`${col}-${index}`} onClick={() => this.sortOn(col)}>
                    <div className={cn('d-flex gap-2 text-muted', s.spanContainer)}>
                      {this.renderHeaderCell(col)}
                      {!this.noSortingTypes?.includes(col) && (
                        <Sort
                          direction={this.getTypesTosort(this.props.filter?.sortType) == col ? this.state.direction : 'none'}
                        />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>{vehiclesToShow.filter(v => v).map(vehicle => this.renderRow(vehicle))}</tbody>
          </table>
        ) : (
          <>
            {vehiclesToShow
              .filter(v => v)
              .map(vehicle => (
                <div className="rows">{this.renderCard(vehicle)}</div>
              ))}
          </>
        )}

        {totalCount > limit && (
          <div className={s.pagination}>
            <PaginationComponent
              paginator={this.props.weblogin ? this.state.localPaginator : this.props.paginator}
              selectPage={this.selectPage}
            />
          </div>
        )}
      </div>
    );
  }

  renderCard = vehicle => {
    {
      var weblogin = '0';
      vehicle?.HOOI_uitslag_done && (weblogin = '1');

      !vehicle?.HOOI_inslag_done_date && (weblogin = '2');

      vehicle?.HOOI_inslag_done_date && !vehicle?.HOOI_uitslag_done_date && (weblogin = '3');

      vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1' && (weblogin = '4');

      !vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1' && (weblogin = '5');
    }
    const establishmentName = "In de Wal Auto's B.V.";
    let date =
      typeof vehicle.date_first_allowance === 'number'
        ? dayjs(vehicle.date_first_allowance).format('DD-MM-YYYY')
        : dayjs(vehicle.date_first_allowance, 'DD-MM-YYYY').format('DD-MM-YYYY');
    if (date === 'Invalid Date') {
      date = vehicle.date_first_allowance;
    }
    if (this.props.work) return <LoadingCard />;
    return (
      <CardComponent
        key={vehicle.id}
        id={`item${vehicle.id}`}
        imgURL={`${
          getSirvImgUrlExterior(vehicle?.helga_id || vehicle?.id, '01')
          //foto martijn
        }`}
        title={
          <div className={s.cardTitle}>
            <CheckboxComponent
              disabled={this.props.weblogin}
              className={s.checkbox}
              checked={this.isSelectedVehicle(vehicle.id)}
              onChange={e => this.onSelectVehicle(e, vehicle)}
            />
            <div className={s.containerInfo}>
              <span className={s.cardInfoCar}>
                <strong>
                  {vehicle.brand_name}&nbsp;
                  {vehicle.model_name}
                </strong>
                {vehicle.power ? <> {vehicle.power} Kw</> : ''}
              </span>
              <span>{vehicle.model_info}</span>
            </div>
          </div>
        }
        onClick={e => this.handleClick(e, vehicle.id)}
        label={
          <div className={s.statusCard}>
            <VehicleStatusLabel key={vehicle.id} status={vehicle.status}>
              {getVehicleStatusLabel(vehicle.status || 0, this.lbl, vehicle)}
            </VehicleStatusLabel>
          </div>
        }
      >
        <div className={cn('text-muted', s.gridCard)}>
          <div className={s.gridCardColumn}>
            <h6 className={s.gridCardItem}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</h6>
            <h6 className={s.gridCardItem}>{date?.split?.('-').pop() ?? '-'}</h6>
            <h6 className={s.gridCardItem}>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.transmission_type?.charAt(0).toUpperCase() + vehicle?.transmission_type?.slice(1) ?? '-'}
            </h6>
          </div>

          <div className={s.gridCardColumn}>
            <h6 className={s.gridCardItem}>{vehicle?.vin ?? '-'}</h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.tax_type?.charAt(0).toUpperCase() + vehicle?.tax_type?.slice(1) ?? '-'}
            </h6>
            <h6 className={s.gridCardItem}>
              {vehicle?.fuel_type?.charAt(0).toUpperCase() + vehicle?.fuel_type?.slice(1) ?? '-'}
            </h6>
            <h6 className={s.gridCardItem}>
              <span>{this.lbl('vehicles.overview.column.b2bPrice')}: </span>
              {formatCurrency(vehicle?.financial_price_b2c) ?? '-'}
            </h6>
          </div>
        </div>
        <div className={s.buttonCard}>
          <div className={s.button}></div>

          {this.state.isShowMore && (
            <div className={s.isHomeContainerCard}>
              {vehicle.location_company_id == '4' ? (
                <span style={{ color: 'rgb(21, 172, 121)' }}>
                  <Home />
                </span>
              ) : (
                <span style={{ color: 'rgba(0,0,0, 0.15)' }}>
                  <Home />
                </span>
              )}
              {/* {vehicle.show_on_sales_website == '1' ? (
                <img
                  style={{ cursor: 'pointer', marginRight: '5px' }}
                  onClick={() => window.open(`https://indewal.nl/vindat/vehicles/${vehicle.id}`)}
                  src="https://indewal.nl/public/images/logo_element.svg"
                  width="18"
                />
              ) : (
                <img
                  style={{ cursor: 'pointer', opacity: '0.25', marginRight: '5px' }}
                  onClick={() => window.open(`https://indewal.nl/vindat/vehicles/${vehicle.id}`)}
                  src="https://indewal.nl/public/images/logo_element.svg"
                  width="18"
                />
              )} */}

              {/* {vehicle.hexon_status_exportwagen == '1' ? (
                //mobile
                <img
                  style={{ cursor: 'pointer', marginRight: '5px' }}
                  onClick={() => window.open(`https://indewal.nl/vindat/vehicles/${vehicle.id}`)}
                  src="https://vindat.indewal.nl/storage/documents/f15d3013-9314-42b6-abef-0659d3523cc8.png"
                  width="18"
                />
              ) : (
                <img
                  style={{ cursor: 'pointer', opacity: '0.15', marginRight: '5px' }}
                  onClick={() => window.open(`https://indewal.nl/vindat/vehicles/${vehicle.id}`)}
                  src="https://vindat.indewal.nl/storage/documents/f15d3013-9314-42b6-abef-0659d3523cc8.png"
                  width="18"
                />
              )} */}
              {this.renderRemarkText(vehicle?.remarks, vehicle?.id)}

              {vehicle.show_on_sales_website == '1' ? vehicle?.advertised : ''}
              {vehicle.incoming_invoice_finalized == '1' ? (
                <span style={{ color: '#cc0040' }}>
                  <ArrowDown />
                </span>
              ) : (
                <span style={{ color: `rgba(0,0,0,${vehicle.incoming_invoice_generated ? '0.15' : '0'})` }}>
                  <ArrowDown />
                </span>
              )}
              {vehicle.outgoing_invoice_finalized == '1' ? (
                <span style={{ color: '#0BCF97' }}>
                  <ArrowUp />
                </span>
              ) : (
                <span style={{ color: `rgba(0,0,0,${vehicle.outgoing_invoice_generated ? '0.15' : '0'})` }}>
                  <ArrowUp />
                </span>
              )}
              {vehicle.active_claim == '1' ? (
                <img
                  style={{ cursor: 'pointer' }}
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                  width="18"
                />
              ) : (
                <img
                  style={{ cursor: 'pointer', opacity: '0.1' }}
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                  width="18"
                />
              )}
            </div>
          )}
        </div>
      </CardComponent>
    );
  };

  handleClick(event, itemId) {
    this.props.setScrollPosition(`#item${itemId}`);
    this.to(`/vehicles/${itemId}`, event?.ctrlKey || event?.metaKey);
  }

  isHovered(hoveredOption, vehicleId) {
    this.setState({ isHover: hoveredOption, hoveredId: vehicleId });
  }

  renderRemarkText(remarks, vehicleId) {
    if (!remarks?.length) {
      return (
        <img
          style={{ cursor: 'pointer', opacity: '0.15', marginRight: '5px' }}
          src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
          title="Remarks_109099090"
          width="18"
        />
      );
    }
    let parsedRemarks = JSON.parse(remarks);
    return (
      <RemarkDataIconWrapper innerWidth={window.innerWidth}>
        <a onMouseEnter={() => this.isHovered('hoveredRemarks', vehicleId)} onMouseLeave={() => this.isHovered(false)}>
          <img
            className="data-remark-image"
            style={{ cursor: 'pointer', marginRight: '5px' }}
            src="https://vindat.indewal.nl/storage/documents/ca10dd49-aac5-4351-a014-a3cfeee9f88d.png"
            width="18"
          />
          {this.state.isHover === 'hoveredRemarks' && this.state.hoveredId === vehicleId && (
            <div className="alt-block">
              {parsedRemarks?.map((remark, index) => (
                <strong style={{ display: 'block' }} key={remark?.id}>{`${index + 1}. ${remark?.text}\n`}</strong>
              ))}
            </div>
          )}
        </a>
      </RemarkDataIconWrapper>
    );
  }

  renderText(text) {
    return <strong>{text}</strong>;
  }

  handleTableRowClick = (event, vehicleId) => {
    const excludeElements = ['input', 'img'];
    const targetElement = event.target.tagName.toLowerCase();
    if (!excludeElements.includes(targetElement)) {
      this.handleClick(event, vehicleId);
    }
  };

  renderRow(vehicle) {
    console.dir(vehicle);
    return (
      <tr
        className={`align-middle ${s.thead}`}
        key={vehicle.id}
        id={`item${vehicle.id}`}
        onClick={event => this.handleTableRowClick(event, vehicle.id)}
      >
        <td className={s.bodyTd}>
          <div className={s.checkboxContainerTd}>
            <CheckboxComponent
              disabled={this.props.weblogin}
              checked={this.isSelectedVehicle(vehicle.id)}
              onChange={e => this.onSelectVehicle(e, vehicle)}
            />
          </div>
        </td>

        {this.cols().map(col => (
          <td className={s.bodyTd}>{this.renderCell(col, vehicle)}</td>
        ))}
      </tr>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      case 'transmission_type':
        return <img width="16" src="/public/images/icon_car_shift.svg" />;
        break;
      case 'isHome':
        return '';
      default:
        return this.lbl(`vehicles.overview.column.${col}`);
    }
  }

  renderCell(col, vehicle) {
    {
      var weblogin = '0';
      vehicle?.HOOI_inslag_done_date && (weblogin = '1');

      !vehicle?.HOOI_inslag_done_date && (weblogin = '2');

      vehicle?.HOOI_inslag_done_date && !vehicle?.HOOI_uitslag_done_date && (weblogin = '3');

      vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1' && (weblogin = '4');

      !vehicle?.HOOI_uitslag_done && vehicle?.outgoing_invoice_finalized == '1' && (weblogin = '5');
    }

    let date =
      typeof vehicle.date_first_allowance === 'number'
        ? dayjs(vehicle.date_first_allowance).format('DD-MM-YYYY')
        : dayjs(vehicle.date_first_allowance, 'DD-MM-YYYY').format('DD-MM-YYYY');
    let economicPrize = 0;
    const establishmentName = "In de Wal Auto's B.V.";

    const key = `${col}-${vehicle.id}`;
    if (date === 'Invalid Date') {
      date = vehicle.date_first_allowance;
    }

    if (vehicle['tax_type'] === 'BTW') {
      economicPrize = (+vehicle?.financial_purchase_price_incl_vat_bpm || 0) + (+vehicle?.extra_cost_sum || 0);
    }
    if (vehicle['tax_type'] === 'marge') {
      economicPrize = (+vehicle?.financial_purchase_price_marge_bpm || 0) + (+vehicle?.extra_cost_sum || 0);
    }

    const historyB2B = vehicle?.b2b_price_change_history ? JSON.parse(vehicle?.b2b_price_change_history)?.reverse() : [];

    const fn = () => {
      switch (col) {
        case 'regplate':
          return (
            <div className={cn('text-wrap', s.reglateCar)} key={key}>
              <div className={s.licensePlate}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</div>
              <div>{vehicle.vin?.substr(-6)}</div>
              <div>ID: {vehicle.id}</div>
            </div>
          );
        case 'vin':
          return vehicle.vin;

        case 'year':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>
                {' '}
                <>{vehicle.date_first_allowance != null ? <> {dayjs(date, 'DD-MM-YYYY').format('DD-MM-YYYY')} </> : ''}</>
              </div>
              <div>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</div>
            </div>
          );
        case 'mileage':
          return;
        case 'workflow_id':
          return (
            <div>
              {vehicle?.workflow_id && (
                <WithWorkflow label shortLabel workflow_id={vehicle?.workflow_id} propertyName={'name'} />
              )}
            </div>
          );
        case 'info':
          return (
            <div key={key} className={s.gridContainer}>
              <div>
                <VehicleAvatar vehicle={vehicle} />
              </div>

              <div className={s.carInformation}>
                <div className={s.brandName}>
                  {vehicle.brand_name} {vehicle.model_name} | {vehicle.power ? <>{vehicle.power} Kw</> : ''}
                </div>
                <div className={s.modelInfo}>{vehicle.model_info}</div>
              </div>
            </div>
          );
          break;

        case 'transmission_type':
          try {
            let t = vehicle.transmission_type?.toLowerCase();
            if (t == 'handmatig' || t.toLowerCase().indexOf('m') === 0) t = 'M';
            if (t == 'automatic') t = 'A';
            if (t == 'automaat') t = 'A';
            return (
              <div>
                <div style={{ fontWeight: '600' }}>{t}</div>
                <div>{vehicle.base_color == 'Niet van toepassing' ? '' : vehicle.base_color ?? ''}</div>
              </div>
            );
            return t;
          } catch (e) {
            return vehicle.transmission_type;
          }
        case 'financPurchPriceInclVat':
          return formatCurrency(economicPrize);
        case 'b2cPrice':
          return <div style={{ fontWeight: '600' }}>{formatCurrency(vehicle['financial_price_b2c'])}</div>;
        case 'b2bPrice':
          return (
            <div key={key}>
              <div style={{ fontWeight: '600' }}>
                <RemarkDataIconWrapper>
                  <a
                    onMouseEnter={() => this.isHovered('hoveredB2B', vehicle?.id)}
                    onMouseLeave={() => this.isHovered(false)}
                  >
                    <div>{formatCurrency(vehicle?.financial_price_b2b_incl_vat_btpm) ?? '-'}</div>
                    {historyB2B?.length && this.state.isHover === 'hoveredB2B' && this.state.hoveredId === vehicle?.id && (
                      <div className="alt-block">
                        {historyB2B?.map((log, index) => (
                          <strong style={{ display: 'block', color: index == 0 ? 'black' : '' }}>{`${dayjs(
                            new Date(log?.date),
                          ).format('DD-MM-YYYY')} ${log.price ? '| ' + formatCurrency(log?.price) : ''} ${
                            log?.name ? '| ' + log?.name : ''
                          } ${log?.surname ?? ''}`}</strong>
                        ))}
                      </div>
                    )}
                  </a>
                </RemarkDataIconWrapper>
              </div>
              <div>{vehicle.tax_type}</div>
            </div>
          );
          return;
        case 'restBpm':
          return formatCurrency(vehicle['rest_bpm']);

        case 'priceType':
          return;
          break;
        case 'buying_contact':
          return `${getPropByName(vehicle.buyingContact, 'name') || ''} ${getPropByName(vehicle.buyingContact, 'surname') ||
            ''}`;
        case 'status':
          return (
            <VehicleStatusLabel key={vehicle.id} status={vehicle.status}>
              {getVehicleStatusLabel(vehicle.status || 0, this.lbl, vehicle)}
            </VehicleStatusLabel>
          );
        case 'in_uitslag':
          //action_ws1_1_labels_done
          return (
            // <>{vehicle.action_ws1_1_labels_done != '1' ? <> {dayjs(vehicle.date_expected).format('DD-MM-YYYY')} </> : ''}</>

            <div key={key}>
              <div style={{ fontWeight: '600', whiteSpace: 'nowrap' }}>
                <>{vehicle.HOOI_inslag_done_date != null ? <> {getDate(vehicle.HOOI_inslag_done_date)} </> : ''}</>
              </div>
              <>{vehicle.HOOI_uitslag_done_date != null ? <> {getDate(vehicle.HOOI_uitslag_done_date)} </> : ''}</>
            </div>
          );
        case 'stadagen':
          let days = 'Te verwachten';
          if (vehicle.HILT_inslag_done_date) {
            days = getDaysInStock(vehicle);
          }

          if (vehicle.task_HILT_check_in === '1') {
            days = vehicle.counter_2_count || '-';
          }

          return (
            <div key={key} left>
              <div style={{ fontWeight: '400', whiteSpace: 'nowrap' }}>{days || '-'}</div>
              {/* <div>{vehicle.import == '1' ? 'Import' : ''}</div> */}
            </div>
          );

        case 'isHome':
          return (
            <div className={s.isHomeContainer}>
              {vehicle.location_address_id === '6' ? (
                <span style={{ color: 'rgb(0, 153, 76)' }}>
                  <Home />
                </span>
              ) : vehicle.location_address_id === '5' ? (
                <span style={{ color: 'rgb(37, 150, 190)' }}>
                  <Home />
                </span>
              ) : vehicle.location_address_id === '4' ? (
                <span style={{ color: 'rgb(200, 0, 0)' }}>
                  <Home />
                </span>
              ) : (
                <span style={{ color: 'rgba(0,0,0, 0.15)' }}>
                  <Home />
                </span>
              )}
              {vehicle?.task_HILT_purchase_release_tdn_insurance == '0' ? 
              (
                  <span style={{ color: 'red' }}>
                    <a
                      href={`https://ovi.rdw.nl/?kenteken=${vehicle?.regplate}`}
                      target="_blank"
                      onClick={e => e.stopPropagation()}
                      style={{ color: 'inherit' }}
                      title="in bedrijfsvoorraad"
                    >
                      <Car style={{ color: 'red' }} />
                    </a>
                  </span>
                ) : (
                  <span style={{ color: 'green' }}>
                    <a
                      href={`https://ovi.rdw.nl/?kenteken=${vehicle?.regplate}`}
                      target="_blank"
                      onClick={e => e.stopPropagation()}
                      style={{ color: 'inherit' }}
                      title="Niet in bedrijfsvoorraad"
                    >
                      <Car style={{ color: 'green' }} />
                    </a>
                  </span>
                )}

              {/* Only for hooikammer installation, for IDW it is claim */}
              {vehicle.remarks != null ? (
                <img
                  style={{ cursor: 'pointer' }}
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                  width="18"
                />
              ) : (
                <img
                  style={{ cursor: 'pointer', opacity: '0.1' }}
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/OOjs_UI_icon_alert-warning.svg/1024px-OOjs_UI_icon_alert-warning.svg.png"
                  width="18"
                />
              )}
            </div>
          );

        //   if (getPropByName(vehicle.locationCompany, 'name') != establishmentName) return;

        //   return (
        //     <span style={{ color: 'rgb(21, 172, 121)' }}>
        //       <Home />
        //     </span>
        //   );
        default:
          return vehicle[col];
      }
    };
    return (
      <div className={`col-${col}`} key={`${col}-${vehicle.id}`}>
        {fn()}
      </div>
    );
  }
}

VehiclesOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicles: selectVehicles(),
    filter: selectVehicleFilter(),
    count: selectVehicleCount(),
    paginator: selectVehiclePaginator(),
    bulkActionsList: selectVehicleBulkActionsList(),
    notification: selectNotification(),
    work: selectWorks([REQUEST_VEHICLES, REQUEST_VEHICLE_FROM_AUTOTELEX]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      //this also fetches the vehicles:
      dispatch(changeVehicleFilter('searchString', ''));
      //dispatch(fetchVehicles());
    },
    changeFilter: (name, value) => {
      dispatch(changeVehicleFilter(name, value));
    },
    addVehicleToBulkActionsList(vehicle, vehicles, page) {
      dispatch(addVehicleToBulkActionsList(vehicle, vehicles, null, page));
    },
    removeAllVehicleFromBulkActionList(page) {
      dispatch(removeAllVehicleFromBulkActionsList(() => {}, page));
    },
    removeVehicleFromBulkActionsList(vehicleId, page) {
      dispatch(removeVehicleFromBulkActionsList(vehicleId, page));
    },
    setScrollPosition(pos) {
      dispatch(setScrollPosition(pos));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    async setSort(type, order) {
      try {
        const result = await dispatch(setVehiclesSort(type, order));
        if (result?.type == SET_VEHICLES_SORT) {
          const result2 = await dispatch(applyVehicleFilters());
        }
      } catch (e) {}
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehiclesOverview = compose(withConnect, withRouter)(VehiclesOverviewComp);
